// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ebUQ","fullView":"styles_fullView__2dJU4"};